<template>
  <NuxtLink :class="computedClasses">
    <span class="sr-only">RVezy</span>
    <LogoRvezy
      :variant="variant"
      class="max-h-full w-auto"
    />
  </NuxtLink>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  size?: 'md' | 'sm'
  variant?: 'standard' | 'white'
}>(), {
  size: 'md',
  variant: 'standard',
})

const computedSizeClasses = computed(() => ({
  'h-[36px]': props.size === 'sm',
  'h-[48px]': props.size === 'md',
}))

const computedClasses = computed(() => [
  'block',
  computedSizeClasses.value,
])
</script>
